import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { ROUTES } from "@/lib/constants";
import type { UserRole } from "@/lib/types";

interface RoleGuardProps {
  requiredRole: UserRole;
}

function RoleGuard({ requiredRole }: RoleGuardProps) {
  const { role } = useAuth();

  if (role !== requiredRole) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
}

export { RoleGuard };
